import { render, staticRenderFns } from "./hostedEmailSecurity.vue?vue&type=template&id=8ce15a80&scoped=true&"
import script from "./hostedEmailSecurity.vue?vue&type=script&lang=tsx&"
export * from "./hostedEmailSecurity.vue?vue&type=script&lang=tsx&"
import style0 from "./hostedEmailSecurity.vue?vue&type=style&index=0&id=8ce15a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce15a80",
  null
  
)

export default component.exports